module.exports = {
  path: '2012',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./main'))
    })
  }
}



// WEBPACK FOOTER //
// ./src/routes/Pictures/DevelopmentAndPlanting/2012/index.js